import * as React from "react";
export default function VehicleBreadcrumbs(_a) {
    var _b, _c, _d, _e;
    var vehicle = _a.vehicle;
    if (!vehicle) {
        return null;
    }
    var text = [
        (_b = vehicle.year) === null || _b === void 0 ? void 0 : _b.name,
        (_c = vehicle.make) === null || _c === void 0 ? void 0 : _c.name,
        (_d = vehicle.model) === null || _d === void 0 ? void 0 : _d.name,
        (_e = vehicle.trim) === null || _e === void 0 ? void 0 : _e.name,
    ]
        .filter(function (val) { return typeof val === "string"; })
        .join(" ");
    return (React.createElement("p", { className: "mb-2 line-clamp-2 flex-none text-ellipsis text-black-300" }, text));
}
